// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const createTimesheetProposalPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createTimesheetProposalHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Proposal created successfully
 */
export const createTimesheetProposal201Schema = z.object({
  proposal: z.object({
    id: z.coerce.string(),
    date: z.string().date(),
    user_id: z.optional(z.number().int()),
    status: z.enum(["pending", "accepted", "rejected", "edited"]),
    log: z.optional(z.array(z.object({}))),
    metadata: z.optional(z.object({})),
    created_at: z.optional(z.coerce.string()),
    updated_at: z.coerce.string().nullish(),
    entries: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      date: z.string().date(),
      timely_project_id: z.number().int().nullish(),
      timely_label_ids: z.optional(z.array(z.number().int())),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      hour_id: z.number().int().nullish(),
      note: z.coerce.string().nullish(),
      duration_minutes: z.number().int().nullish(),
      resource_id: z.coerce.string().nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
    items: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      timesheet_proposal_entry_id: z.number().int().nullish(),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      note: z.coerce.string().nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
  }),
});

/**
 * @description Validation failed
 */
export const createTimesheetProposal400Schema = z.object({
  message: z.coerce.string(),
  errors: z.optional(z.array(z.object({
    field: z.optional(z.coerce.string()),
    message: z.optional(z.coerce.string()),
    code: z.optional(z.coerce.string()),
  }))),
});

export const createTimesheetProposalMutationRequestSchema = z.object({
  date: z.string().date(),
  timely_user_id: z.optional(z.number().int()),
  timely_account_id: z.optional(z.number().int()),
  metadata: z.optional(z.object({})),
});

export const createTimesheetProposalMutationResponseSchema = z.lazy(() => createTimesheetProposal201Schema);
